export default {
  data () {
    return {
      form: {
        schema: {
          id: 0,
          name: 'Loading..'
        },
        data: {},
        loaded: false,
        loading: false,
        submitted: false,
        hasPendingSubmissions: 0,
        hasCompletedSubmissions: 0
      }
    }
  },
  methods: {
    loadForm (id) {
      this.axios.get('/submissions?form_id=' + id + '&user_id=' + this.$auth.user().id).then(rsp => {
        this.form.hasPendingSubmissions = rsp.data.data.filter(submission => submission.grade_status === 2).length
        this.form.hasCompletedSubmissions = rsp.data.data.filter(submission => submission.grade_status === 1).length
      })

      this.axios.get('/forms/' + id).then((rsp) => {
        let form = rsp.data
        form.loaded = false
        form.submitted = false
        form.loading = false

        this.form = Object.assign(this.form, form)
        this.restoreSavedFormGroup(id).then(() => {
          this.form.loaded = true
        })
      }).catch((err) => {
        this.$errorOut(err)
      })
    },
    restoreSavedFormGroup (id) {
      return this.axios.get('/submissions/' + id + '/sync').then(rsp => {
        return new Promise((resolve) => {
          this.form.schema.components.forEach(field => {
            if (field.type === 'file') {
              this.$set(this.form.data, field.name, rsp.data[field.name] || [])
            } else if (field.type === 'button') {
              // Continue
            } else if (field.type === 'selectboxes') {
              let fieldData = {};
              field.values.forEach((v) => {
                fieldData[v.label] = false;
                if(rsp.data[field.name] && rsp.data[field.name][v.label]) {
                  fieldData[v.label] = rsp.data[field.name][v.label]
                }
              })
              this.$set(this.form.data, field.name, fieldData)
            } else {
              this.$set(this.form.data, field.name, rsp.data[field.name] || '')
            }
          })
          resolve()
        })
      })
    },
    submitForm (data) {
      return new Promise((resolve, reject) => {
        let submission = {
          user_id: this.$auth.user().id,
          form_id: this.form.id,
          form_name: this.form.name,
          form_schema: this.form.schema,
          form_data: data
        }

        this.form.loading = true

        this.axios.post('/submissions', submission).then(() => {
          this.$swal('Success', 'Form has been submitted', 'success')
          resolve()
          this.form.submitted = true
        }).catch(err => {
          this.$errorOut(err)
          reject()
        })
      })
    }
  }
}
